import React from 'react';
import { getProjectTypeText } from '../helpers/typeProject';
import './Path.less';

const dataDefault = [
  { title: 'Отчетность СП за предыдущий год', active: false },
  { title: 'Планирование СП на текущий год', active: false },
  { title: 'Реализация СП', active: true },
];

export default function Path({ type }) {
  return (
    <section className="path">
      {(dataDefault).map((d, i) => (
        <div key={i} className={`path-item ${d.active ? 'active' : ''}`}>
          {type === 'strategy'
            ? d.title
            : d.title.replace('СП', getProjectTypeText(type))}
        </div>
      ))}
    </section>
  );
}
